'use strict';

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var AbstractUnicast = require('./../abstract/abstract-unicast.js');

var UnicastDefinition = require('unicast-definition');
/**
 * Unicast represent the base implementation of an unicast protocol for the foglet library.
 * @extends AbstractUnicast
 * @author Arnaud Grall (Folkvir)
 */


var Unicast =
/*#__PURE__*/
function (_AbstractUnicast) {
  _inherits(Unicast, _AbstractUnicast);

  /**
   * Constructor
   * @param  {AbstractNetwork} source - The source RPS/overlay
   * @param  {string} protocol - The name of the unicast protocol
   */
  function Unicast(source, protocol) {
    var _this;

    _classCallCheck(this, Unicast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Unicast).call(this, source, protocol));
    _this._unicast = new UnicastDefinition(_this._source.rps, {
      pid: _this._protocol
    });

    _this._unicast.on(_this._protocol, function (id, message) {
      _this._receive(id, message);
    });

    return _this;
  }
  /**
   * Send a message to a peer using its ID.
   * This peer must be a neighbour.
   * @param  {string}  id  - The id to send the message
   * @param  {*} message - The message to send
   * @return {Promise} A Promise fulfilled when the message is sent
   */


  _createClass(Unicast, [{
    key: "send",
    value: function send(id, message) {
      return this._unicast.emit(this._protocol, id, this._source.outviewId, message);
    }
    /**
     * Send a message to multiple peers
     * @param  {string[]} ids - Set of peer IDs
     * @param  {Object} message - Message to send
     * @return {Promise} A Promise fulfilled when all message have been sent
     */

  }, {
    key: "sendMultiple",
    value: function sendMultiple() {
      var _this2 = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var message = arguments.length > 1 ? arguments[1] : undefined;
      return ids.reduce(function (prev, peerID) {
        return prev.then(function () {
          return _this2.send(peerID, message);
        });
      }, Promise.resolve());
    }
    /**
     * Handler executed when a message is recevied
     * @param  {string} id  - Message issuer's ID
     * @param  {*} message - The message received
     * @return {void}
     */

  }, {
    key: "_receive",
    value: function _receive(id, message) {
      this.emit('receive', id, message);
    }
  }]);

  return Unicast;
}(AbstractUnicast);

module.exports = Unicast;